import React from 'react';
import { Box, Typography, Grid } from '@mui/material';

const InvoiceDetailsCard = ({ invoiceData }) => {
  return (
    <Box
      sx={{
        background: '#F8F9FA',
        borderRadius: '8px',
        padding: '20px',
        mb: 3,
      }}
    >
      {/* <Typography
        sx={{
          fontSize: '16px',
          fontFamily: 'Inter',
          fontWeight: 600,
          mb: 2,
          color: '#192126',
          textAlign: 'left',
        }}
      >
        Invoice Details
      </Typography> */}
      <Grid container spacing={2}>
        {/* <Grid item xs={4}>
          <Typography
            sx={{
              fontSize: '16px',
              fontFamily: 'Inter',
              fontWeight: 600,
              color: '#192126',
              mb: 0.5,
              textAlign: 'left',
            }}
          >
            Title
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              fontFamily: 'Inter',
              fontWeight: 400,
              color: '#667085',
              textAlign: 'left',
            }}
          >
            {invoiceData.title}
          </Typography>
        </Grid> */}
        <Grid item xs={12}>
          <Typography
            sx={{
              fontSize: '16px',
              fontFamily: 'Inter',
              fontWeight: 600,
              color: '#192126',
              mb: 0.5,
              textAlign: 'left',
            }}
          >
            Invoice No
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              fontFamily: 'Inter',
              fontWeight: 400,
              color: '#667085',
              textAlign: 'left',
            }}
          >
            {invoiceData.invoiceNo}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography
            sx={{
              fontSize: '16px',
              fontFamily: 'Inter',
              fontWeight: 600,
              color: '#192126',
              mb: 0.5,
              textAlign: 'left',
            }}
          >
            Vendor Name
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              fontFamily: 'Inter',
              fontWeight: 400,
              color: '#667085',
              textAlign: 'left',
            }}
          >
            {invoiceData.vendorName}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography
            sx={{
              fontSize: '16px',
              fontFamily: 'Inter',
              fontWeight: 600,
              color: '#192126',
              mb: 0.5,
              textAlign: 'left',
            }}
          >
            Invoice Date
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              fontFamily: 'Inter',
              fontWeight: 400,
              color: '#667085',
              textAlign: 'left',
            }}
          >
            {invoiceData.invoiceDate}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography
            sx={{
              fontSize: '16px',
              fontFamily: 'Inter',
              fontWeight: 600,
              color: '#192126',
              mb: 0.5,
              textAlign: 'left',
            }}
          >
            Region
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              fontFamily: 'Inter',
              fontWeight: 400,
              color: '#667085',
              textAlign: 'left',
            }}
          >
            {invoiceData.region}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography
            sx={{
              fontSize: '16px',
              fontFamily: 'Inter',
              fontWeight: 600,
              color: '#192126',
              mb: 0.5,
              textAlign: 'left',
            }}
          >
            PO Number
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              fontFamily: 'Inter',
              fontWeight: 400,
              color: '#667085',
              textAlign: 'left',
            }}
          >
            {invoiceData.poNumber}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography
            sx={{
              fontSize: '16px',
              fontFamily: 'Inter',
              fontWeight: 600,
              color: '#192126',
              mb: 0.5,
              textAlign: 'left',
            }}
          >
            PO Status
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              fontFamily: 'Inter',
              fontWeight: 400,
              color: '#667085',
              textAlign: 'left',
            }}
          >
            {invoiceData.poStatus}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography
            sx={{
              fontSize: '16px',
              fontFamily: 'Inter',
              fontWeight: 600,
              color: '#192126',
              mb: 0.5,
              textAlign: 'left',
            }}
          >
            Approval Status
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              fontFamily: 'Inter',
              fontWeight: 400,
              color: '#667085',
              textAlign: 'left',
            }}
          >
            {invoiceData.approvalStatus}
          </Typography>
        </Grid>
        {(invoiceData.status || '').toLowerCase() === 'pending_rejection' &&
          (invoiceData.reason_of_rejection || invoiceData.reasonOfRejection) && (
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: '16px',
                  fontFamily: 'Inter',
                  fontWeight: 600,
                  color: '#192126',
                  mb: 0.5,
                  textAlign: 'left',
                }}
              >
                Rejection Pending Reason
              </Typography>
              <Typography
                sx={{
                  fontSize: '14px',
                  fontFamily: 'Inter',
                  fontWeight: 400,
                  color: '#667085',
                  textAlign: 'left',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {invoiceData.reason_of_rejection || invoiceData.reasonOfRejection}
              </Typography>
            </Grid>
          )}
        <Grid item xs={4}>
          <Typography
            sx={{
              fontSize: '16px',
              fontFamily: 'Inter',
              fontWeight: 600,
              color: '#192126',
              mb: 0.5,
              textAlign: 'left',
            }}
          >
            Current Approval
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              fontFamily: 'Inter',
              fontWeight: 400,
              color: '#667085',
              textAlign: 'left',
            }}
          >
            {invoiceData.currentApprover || '-'}
            {invoiceData.currentApprover && invoiceData.currentApproverEmail
              ? ` ${invoiceData.currentApproverEmail}`
              : ''}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography
            sx={{
              fontSize: '16px',
              fontFamily: 'Inter',
              fontWeight: 600,
              color: '#192126',
              mb: 0.5,
              textAlign: 'left',
            }}
          >
            Previous Approval
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              fontFamily: 'Inter',
              fontWeight: 400,
              color: '#667085',
              textAlign: 'left',
            }}
          >
            {invoiceData.previousApprover || '-'}
            {invoiceData.previousApprover && invoiceData.previousApproverEmail
              ? ` ${invoiceData.previousApproverEmail}`
              : ''}
          </Typography>
        </Grid>
      </Grid>

      {invoiceData.reasonOfRejection && (
        <Box sx={{ mt: 3 }}>
          <Typography
            sx={{
              fontSize: '16px',
              fontFamily: 'Inter',
              fontWeight: 600,
              color: '#192126',
              mb: 0.5,
              textAlign: 'left',
            }}
          >
            Reason of Rejection
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              fontFamily: 'Inter',
              fontWeight: 400,
              color: '#667085',
              textAlign: 'left',
              whiteSpace: 'pre-wrap',
            }}
          >
            {invoiceData.reasonOfRejection}
          </Typography>
        </Box>
      )}

      {/* Vendor Remarks */}
      <Box sx={{ mt: 3 }}>
        <Typography
          sx={{
            fontSize: '16px',
            fontFamily: 'Inter',
            fontWeight: 600,
            mb: 1,
            color: '#192126',
            textAlign: 'left',
          }}
        >
          Vendor Remarks
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
            fontFamily: 'Inter',
            fontWeight: 400,
            color: '#667085',
            textAlign: 'left',
          }}
        >
          {invoiceData.vendorRemarks}
        </Typography>
      </Box>

      {/* PO summary */}
      <Box
        sx={{
          mt: 3,
          pt: 2,
          borderTop: '1px solid #E8E9E9',
        }}
      >
        <Typography
          sx={{
            fontSize: '16px',
            fontFamily: 'Inter',
            fontWeight: 600,
            mb: 2,
            color: '#192126',
            textAlign: 'left',
          }}
        >
          PO Summary
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Typography
              sx={{
                fontSize: '16px',
                fontFamily: 'Inter',
                fontWeight: 600,
                color: '#192126',
                mb: 0.5,
                textAlign: 'left',
              }}
            >
              PO Total Amount
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
                fontFamily: 'Inter',
                fontWeight: 400,
                color: '#667085',
                textAlign: 'left',
              }}
            >
              {invoiceData.poTotalAmountFormatted ?? '—'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography
              sx={{
                fontSize: '16px',
                fontFamily: 'Inter',
                fontWeight: 600,
                color: '#192126',
                mb: 0.5,
                textAlign: 'left',
              }}
            >
              Already Booked Amount
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
                fontFamily: 'Inter',
                fontWeight: 400,
                color: '#667085',
                textAlign: 'left',
              }}
            >
              {invoiceData.alreadyClaimedAmountFormatted ?? '—'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography
              sx={{
                fontSize: '16px',
                fontFamily: 'Inter',
                fontWeight: 600,
                color: '#192126',
                mb: 0.5,
                textAlign: 'left',
              }}
            >
              Invoices Created (this PO)
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
                fontFamily: 'Inter',
                fontWeight: 400,
                color: '#667085',
                textAlign: 'left',
              }}
            >
              {invoiceData.poInvoicesCount != null ? invoiceData.poInvoicesCount : '—'}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default InvoiceDetailsCard;
